import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

interface AuthCardProps {
    title: string;
    description?: string;
    children: ReactNode;
    className?: string;
}

export function AuthCard({ title, description, children, className }: AuthCardProps) {
    return (
        <Card className={cn("w-full max-w-md mx-auto", className)}>
            <CardHeader>
                <CardTitle>{title}</CardTitle>
                {description && <CardDescription>{description}</CardDescription>}
            </CardHeader>
            <CardContent>
                {children}
            </CardContent>
        </Card>
    );
}
